var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPennsylvaniaWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 357 66.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.3,26.6l-1,4.4h-16.6V.2h14.9l.7,4.4h-7.8v7h5.2v4.4h-5.2v10.6h9.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.5.3v30.7h-4.4l-12.8-17.3v17.3h-4.4V.3h4.4l12.8,17.5V.3h4.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.7.3v30.7h-4.4l-12.8-17.3v17.3h-4.4V.3h4.4l12.8,17.5V.3h4.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.5.3l-7.7,17v13.7h-7.8v-13.9L157.8.3h8.5l4.6,10.6,5-10.6h4.6,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.1,26.6l-1.1,4.4h-16.7V.3h7.8v26.3s10,0,10,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230,31h-8.3L213.6.3h8.3l5.7,22.8L233.4.3h4.7l-8.1,30.7h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.8,20.8l-2.7-11-2.7,11h5.4ZM268.1,31h-8.2l-1.8-5.8h-8l-1.7,5.8h-4.7L251.8.3h8.2l8.1,30.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.9.3v30.7h-4.4l-12.8-17.3v17.3h-4.4V.3h4.4l12.8,17.5V.3h4.4Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.5.3h7.8v30.7h-7.8V.3Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344.2,20.8l-2.7-11-2.7,11h5.4ZM355.5,31h-8.2l-1.8-5.8h-8l-1.7,5.8h-4.7L339.2.3h8.2l8.1,30.7h0Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.3,8.2c-1.2-1.2-2.5-2.1-3.8-2.7s-2.6-.8-3.7-.8-2.1.3-2.8.8c-.8.5-1.1,1.3-1.1,2.3s.3,1.2,1,1.7c.6.5,1.4.9,2.4,1.4.9.4,2,.9,3.1,1.4s2.2,1.1,3.1,1.9,1.8,1.6,2.4,2.6,1,2.2,1,3.6-.3,2.7-.8,4-1.3,2.4-2.3,3.4-2.1,1.8-3.5,2.4-2.9.8-4.5.8c-1.6-.1-3.4-.5-5.3-1.4s-3.9-2.2-5.9-4l3-4.2c1,1.4,2.1,2.5,3.4,3.3s2.5,1.2,3.6,1.4,2.1,0,2.9-.4,1.2-1.2,1.2-2.2-.3-1.1-.9-1.5-1.4-.9-2.4-1.3-2-.9-3.1-1.4-2.1-1.1-3.1-1.9-1.8-1.7-2.4-2.7c-.6-1.1-.9-2.4-.9-4s.4-3.6,1.1-4.9c.7-1.4,1.7-2.5,2.9-3.4s2.5-1.5,4-1.8,3-.4,4.5-.3,2.9.5,4.3,1.1c1.4.6,2.6,1.5,3.6,2.5l-1,4.3h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,10.9c0-.7-.1-1.4-.4-2-.2-.6-.6-1.2-.9-1.6-.4-.5-.9-.8-1.4-1.1s-1.2-.4-1.8-.4h-1.7v10.2h1.7c.6,0,1.2-.1,1.8-.4s1-.6,1.4-1.1.7-1,.9-1.6c.3-.6.4-1.2.4-2M12.8.3c1.7,0,3.3.3,4.6.8s2.4,1.3,3.3,2.3,1.5,2.2,2,3.5.7,2.8.7,4.4-.2,2-.5,3.3c-.4,1.2-1,2.4-1.8,3.5s-2,2-3.4,2.8-3.2,1.1-5.3,1.1h-3.1v9H1.5V.3h11.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.6,38.7h298.4v2H28.6v-2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,49.8v2.8h4v13.1h3.1v-13.1h4.1v-2.8H0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,49.8v6.6h-6v-6.6h-3.1v15.9h3.1v-6.6h6v6.6h3.1v-15.9s-3.1,0-3.1,0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.6,49.8v15.9h8.9v-2.7h-5.8v-3.9h5.5v-2.7h-5.5v-3.8h5.8v-2.8s-8.9,0-8.9,0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.5,66c-1.1,0-2.1-.2-3-.6-1-.4-1.8-1-2.5-1.7-.7-.8-1.3-1.6-1.7-2.6s-.6-2.1-.6-3.2.2-2.2.6-3.2.9-1.9,1.6-2.6c.7-.8,1.5-1.4,2.5-1.8s2.1-.7,3.3-.7,1.4,0,2.1.2c.7.2,1.4.4,2,.7.7.3,1.2.7,1.8,1.1l-1.5,2.4c-.6-.5-1.2-.9-2-1.2s-1.6-.4-2.3-.4-1.4,0-2,.4-1.1.6-1.5,1.1-.7,1-.9,1.7-.3,1.3-.3,2.1,0,1.6.3,2.2c.2.7.6,1.3,1,1.7.4.5.9.9,1.5,1.1.6.3,1.2.4,1.8.4s1,0,1.5-.3.9-.4,1.3-.7.7-.7.9-1.1.3-.9.3-1.4v-.2h-4.2v-2.4h7.3v2.4c0,1-.2,1.9-.6,2.7s-1,1.5-1.7,2.1c-.7.6-1.5,1-2.3,1.3-.8.4-1.7.6-2.7.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.2,65.7v-15.9h5.4c1.1,0,2,.2,2.8.6s1.4.9,1.9,1.7.7,1.6.7,2.6,0,1.5-.4,2.2c-.3.6-.7,1.2-1.2,1.6s-1.2.8-1.9,1l5.2,6.4h-4l-4.6-6h-.7v6s-3.2-.2-3.2-.2ZM69.3,57.1h1.3c.7,0,1.2,0,1.7-.3.4-.2.8-.5,1-.8.2-.4.4-.8.4-1.3,0-.8-.3-1.4-.8-1.8s-1.3-.6-2.2-.6h-1.3v4.8h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.9,49.8v15.9h8.8v-2.7h-5.7v-3.9h5.5v-2.7h-5.5v-3.8h5.7v-2.8s-8.8,0-8.8,0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.7,54l2.1,5.3h-4.1l2-5.3ZM98.2,49.8l-6.4,15.9h3.4l1.3-3.6h6.2l1.3,3.6h3.4l-6.4-15.9s-2.8,0-2.8,0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.4,49.8v2.8h4v13.1h3.1v-13.1h4v-2.8h-11.1Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.5,54l2.1,5.3h-4.1l2-5.3ZM131,49.8l-6.4,15.9h3.4l1.4-3.6h6.2l1.4,3.6h3.4l-6.4-15.9h-3,0Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.6,49.8l-3.8,10-3.8-10h-3.3l-1.6,15.9h3.2l.9-10.3,3.7,9.9h1.9l3.6-9.9,1,10.3h3.1l-1.6-15.9h-3.3,0Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.3,49.8v15.9h8.9v-2.7h-5.8v-3.9h5.5v-2.7h-5.5v-3.8h5.8v-2.8s-8.9,0-8.9,0Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.2,65.7v-15.9h5.4c1.1,0,2,.2,2.8.6s1.4.9,1.9,1.7c.4.7.7,1.6.7,2.6s-.1,1.5-.4,2.2c-.3.6-.7,1.2-1.2,1.6s-1.2.8-1.9,1l5.2,6.4h-4l-4.6-6h-.7v6l-3.2-.2ZM179.3,57.1h1.3c.6,0,1.2,0,1.6-.3s.8-.5,1-.8c.2-.4.4-.8.4-1.3,0-.8-.3-1.4-.8-1.8s-1.3-.6-2.2-.6h-1.3s0,4.8,0,4.8Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.9,49.8h3.1v15.9h-3.1s0-15.9,0-15.9Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.7,66c-1.2,0-2.3-.2-3.4-.6s-2-1-2.8-1.8-1.4-1.6-1.9-2.6c-.4-1-.7-2.1-.7-3.2s.2-2.2.7-3.2,1.1-1.9,1.9-2.6c.8-.8,1.7-1.3,2.8-1.8,1.1-.4,2.2-.6,3.4-.6s1.9,0,2.8.4,1.6.6,2.3,1.1l-1.4,2.7c-.4-.3-1-.6-1.6-.8s-1.3-.3-1.9-.3-1.5,0-2.2.4-1.3.6-1.8,1.1-.9,1-1.2,1.7c-.3.6-.4,1.3-.4,2s.1,1.4.4,2,.7,1.2,1.2,1.7,1.1.8,1.8,1.1,1.4.4,2.2.4,1.3,0,1.9-.3,1.1-.5,1.6-.8l1.4,2.7c-.6.4-1.4.8-2.2,1.1-1,0-1.9.3-2.9.2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.3,54l2.1,5.3h-4.1l2-5.3ZM217.9,49.8l-6.4,15.9h3.4l1.4-3.6h6.2l1.4,3.6h3.4l-6.4-15.9h-3,0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.7,49.8v10.7l-6.9-10.7h-3.1v15.9h3.1v-10.7l6.9,10.7h3.1v-15.9s-3.1,0-3.1,0Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.4,66c-1.1,0-2.1-.2-3-.6s-1.8-1-2.5-1.7c-.7-.8-1.3-1.6-1.6-2.6-.4-1-.6-2.1-.6-3.2s.2-2.2.6-3.2.9-1.9,1.6-2.6c.7-.8,1.5-1.4,2.5-1.8s2.1-.7,3.3-.7,1.4,0,2.1.2,1.4.4,2,.7,1.2.7,1.8,1.1l-1.6,2.4c-.6-.5-1.2-.9-2-1.2s-1.6-.4-2.3-.4-1.4,0-2,.4-1.1.6-1.5,1.1-.7,1-.9,1.7-.3,1.3-.3,2.1.1,1.6.4,2.2c.2.7.6,1.3,1,1.7.4.5.9.9,1.5,1.1.6.3,1.2.4,1.8.4s1,0,1.5-.3.9-.4,1.3-.7.7-.7.9-1.1.3-.9.3-1.4v-.2h-4.2v-2.4h7.4v2.4c0,1-.2,1.9-.6,2.7s-1,1.5-1.6,2.1c-.7.6-1.5,1-2.4,1.3-1.1.4-2,.6-2.9.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270,49.8v15.9h8.9v-2.7h-5.8v-3.9h5.5v-2.7h-5.5v-3.8h5.8v-2.8s-8.9,0-8.9,0Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.1,49.8v2.8h4v13.1h3.1v-13.1h4.1v-2.8h-11.2Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.9,54l2.1,5.3h-4.1l2-5.3ZM298.5,49.8l-6.4,15.9h3.4l1.4-3.6h6.2l1.4,3.6h3.4l-6.4-15.9s-3,0-3,0Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325.5,49.8l-3,11.7-3.4-11.7h-2.3l-3.4,11.7-3-11.7h-3.5l4.6,15.9h3.5l2.9-9.8,3,9.8h3.5l4.6-15.9h-3.5Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.8,54l2.1,5.3h-4.1l2-5.3ZM334.4,49.8l-6.4,15.9h3.4l1.4-3.6h6.2l1.4,3.6h3.4l-6.4-15.9s-3,0-3,0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.2,49.8l-3.6,5.7-3.6-5.7h-3.7l5.7,8.9v7h3.2v-7l5.8-8.9s-3.8,0-3.8,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPennsylvaniaWhite);
export default __webpack_public_path__ + "static/media/pennsylvania-white.355dd2461b8b471afadfb1f21e7ccf5e.svg";
export { ForwardRef as ReactComponent };